import { styled } from '@grupoboticario/flora';
import { ModalCloseButton } from '@grupoboticario/flora-react';
import { theme } from 'ui/theme';

export const ModalCloseButtonStyle = styled(ModalCloseButton, {
  svg: {
    path: {
      fill: `${theme.colors.action.navigation.standard.static}`,
    },
  },
});
